import { MultiValue, Props, SingleValue } from "react-select";

export type OptionType = { value: string; label: string; icon?: JSX.Element };

export type SelectValue<
  CustomOptionType = OptionType,
  IsMulti extends boolean = false,
> = CustomOptionType extends OptionType
  ? IsMulti extends true
    ? CustomOptionType[]
    : CustomOptionType
  : MultiValue<OptionType> | SingleValue<OptionType>;

export type ComponentsClassNames = {
  dropdownIndicator?: string;
  option?: string;
  singleValue?: string;
  multiValue?: string;
  menuList?: string;
  placeholder?: string;
  input?: string;
  menu?: string;
};

export type SelectProps<CustomOptionType, IsMulti extends boolean = false> = {
  className?: string;
  options: OptionType[];
  componentsClassNames?: ComponentsClassNames;
  isMulti?: IsMulti;
  isDropDownMenuRelative?: boolean;
  handleChange: CustomSelectHandleChangeFunc<CustomOptionType, IsMulti>;
  isInputTypingEnabled?: boolean;
  selectedIndicator?: "checkmark" | "checkbox" | "none";
  placeholderDataTestId?: string;
  lazyLoadedMenuList?: boolean;
  lazyLoadedMenuListRowHeight?: number;
} & Omit<Props<OptionType>, "onChange">;

export type CustomSelectHandleChangeFunc<CustomOptionType, IsMulti extends boolean = false> = (
  value: SelectValue<CustomOptionType, IsMulti>
) => void;
